/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { renderContainer } from '@g17eco/molecules/direct-route-container';
import { Loader } from '@g17eco/atoms/loader';
import {
  ExternalLoginForm
} from './login-modal/ExternalLoginForm';
import { useLocation, useParams } from 'react-router-dom';
import G17Client from '../../services/G17Client';
import { ReduxReducer } from '@reducers/types';
import { IdentityProvider } from '../../types/sso';
import Logo from '../../images/logo.svg';
import { Footer } from '@g17eco/molecules/footer';
import { showLogin } from '../../actions/login';
import './SsoRoute.scss';

export const SsoRoute = () => {

  const [ssoConfig, setSsoConfig] = useState<ReduxReducer<IdentityProvider[]>>({
    loaded: false,
    data: [],
    errored: false,
    errorMessage: ''
  });

  const { action, orgCode = '' } = useParams<{ action?: string, orgCode?: string }>();
  const { search } = useLocation();
  const redirect = queryString.parse(search)['redirectUrl'];
  const redirectPath = (Array.isArray(redirect) ? redirect[0] : redirect) ?? '';

  useEffect(() => {
    document.title = 'G17Eco - Single Sign On';
  }, [])

  useEffect(() => {
    G17Client.getIdentityProviders(orgCode)
      .then(data => setSsoConfig((d) => ({ ...d, loaded: true, data })))
      .catch(e => setSsoConfig((d) => ({ ...d, errored: true, erorrMessage: e.message})))
  }, [orgCode]);

  useEffect(() => {
    if (!action) {
      showLogin(redirectPath);
    }
  }, [action, redirectPath]);

  if (!action) {
    // Redirecting to default SSO login...
    return <Loader />;
  }

  if (ssoConfig.errored) {
    return renderContainer(
      <div className='headerTop'/>,
      <h1 className='mt-5 text-center'>{ssoConfig.errorMessage}</h1>
    );
  }

  if (!ssoConfig.loaded) {
    return <Loader/>;
  }

  return (
    <div className='sso-route'>
      <div className='sso-route-container mt-5'>
        <div className='sso-route-container-body p-3'>
          <header className={'my-5'}>
            <img className='logo' src={Logo} width={'200'} alt='G17Eco' />
          </header>
          <div className='col-sm-12'>
            <ExternalLoginForm redirectPath={redirectPath} idps={ssoConfig.data} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
};
